/**
 * NDG Booking — view.js
 *
 * Charge le store unifié ndg/event-search.
 * Ce module est nécessaire pour que WordPress enqueue le script
 * quand le bloc booking est présent sur la page.
 */

import '../event-search/view.js';
